"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionGroup = void 0;
var AccordionGroup_1 = __importDefault(require("./AccordionGroup"));
exports.AccordionGroup = AccordionGroup_1.default;
exports.default = AccordionGroup_1.default;
//# sourceMappingURL=index.js.map